import { render, staticRenderFns } from "./VerifyEmailView.vue?vue&type=template&id=4922638a"
import script from "./VerifyEmailView.vue?vue&type=script&lang=js"
export * from "./VerifyEmailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports